import { useEffect, useRef, useState } from 'react'
import { signOut } from '../lib/api'
import { useSession } from '../lib/session'

/** Who you are, top-right, with the way out. */
export function UserChip() {
  const { me, refresh } = useSession()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const away = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false)
    }
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', away)
    document.addEventListener('keydown', esc)
    return () => {
      document.removeEventListener('mousedown', away)
      document.removeEventListener('keydown', esc)
    }
  }, [open])

  if (!me?.user) return null
  const { name, email, picture } = me.user

  return (
    <div className="userchip" ref={ref}>
      <button className="userchip-btn" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <Avatar picture={picture} name={name} />
        <span className="userchip-name">{name}</span>
      </button>
      {open && (
        <div className="menu" role="menu">
          <div className="menu-head">
            <Avatar picture={picture} name={name} size={34} />
            <div style={{ minWidth: 0 }}>
              <div className="menu-name">{name}</div>
              <div className="small muted ellipsis">{email}</div>
            </div>
          </div>
          {me.publisher.connected && me.publisher.channel && (
            <div className="menu-note small muted">
              Publishing to <strong>{me.publisher.channel.title}</strong>
            </div>
          )}
          <button
            className="menu-item"
            onClick={async () => { await signOut(); await refresh() }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}

function Avatar({ picture, name, size = 24 }: { picture?: string; name: string; size?: number }) {
  const [broken, setBroken] = useState(false)
  const style = { width: size, height: size, fontSize: Math.round(size * 0.42) }
  // Google's avatar host occasionally refuses; initials are a fine stand-in.
  if (!picture || broken) {
    return <span className="avatar fallback" style={style}>{initials(name)}</span>
  }
  return (
    <img
      className="avatar"
      style={style}
      src={picture}
      alt=""
      referrerPolicy="no-referrer"
      onError={() => setBroken(true)}
    />
  )
}

const initials = (name: string) =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('') || '?'
